import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contactNumber: "",
    enquiryType: "",
    message: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validate = () => {
    const errors = {};
    if (!formData.name) errors.name = "Name is required";
    if (!formData.email) {
      errors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Email is invalid";
    }
    if (!formData.contactNumber) {
      errors.contactNumber = "Contact number is required";
    } else if (!/^\d{10}$/.test(formData.contactNumber)) {
      errors.contactNumber = "Contact number must be 10 digits";
    }
    if (!formData.enquiryType) errors.enquiryType = "Please select an enquiry type";
    if (!formData.message) errors.message = "Message is required";
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validate();
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      setSubmitted(true);
      setFormData({
        name: "",
        email: "",
        contactNumber: "",
        enquiryType: "",
        message: "",
      });
      setTimeout(() => setSubmitted(false), 5000); // Hide success message after 5 seconds
    }
  };

  return (
    <div className="contact-container">
      <h1>Contact Us</h1>
      <p className="contact-description">
        Reach out to us for inquiries, feedback, or any questions. We’d love to
        hear from you!
      </p>
      {submitted && (
        <p className="success">
          Thank you for your message! We'll be in touch soon.
        </p>
      )}
      <div className="contact-content">
        {/* Google Map */}
        <div className="map-container">
          <iframe
            title="Company Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3763.0777497670815!2d72.84919511161256!3d19.40904636411445!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4e7b2d7fe1467921%3A0x29cd90d3cc157918!2sAPCO%20LIGHT%20INDUSTRIES!5e0!3m2!1sen!2sin!4v1735103211887!5m2!1sen!2sin"
            allowFullScreen=""
            loading="lazy"
          ></iframe>
        </div>
        {/* Contact Form */}
        <form onSubmit={handleSubmit} className="contact-form">
          <div className="form-group">
            <label htmlFor="name">Name</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
            />
            {formErrors.name && <p className="error">{formErrors.name}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="email">Email</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
            />
            {formErrors.email && <p className="error">{formErrors.email}</p>}
          </div>
          <div className="form-group">
            <label htmlFor="contactNumber">Contact Number</label>
            <input
              type="tel"
              id="contactNumber"
              name="contactNumber"
              placeholder="Enter your contact number"
              value={formData.contactNumber}
              onChange={handleChange}
            />
            {formErrors.contactNumber && (
              <p className="error">{formErrors.contactNumber}</p>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="enquiryType">Type of Enquiry</label>
            <select
              id="enquiryType"
              name="enquiryType"
              value={formData.enquiryType}
              onChange={handleChange}
            >
              <option value="">Select an option</option>
              <option value="Product Enquiry">Product Enquiry</option>
              <option value="Ordering">Ordering</option>
              <option value="Career">Career</option>
              <option value="Others">Others</option>
            </select>
            {formErrors.enquiryType && (
              <p className="error">{formErrors.enquiryType}</p>
            )}
          </div>
          <div className="form-group">
            <label htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              placeholder="Enter your message"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            {formErrors.message && <p className="error">{formErrors.message}</p>}
          </div>
          <button type="submit" className="submit-button">
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default Contact;
